import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { BaseService } from '../http/base/base.service';
import { HttpClient } from '@angular/common/http';
import { Subject, map } from 'rxjs';
import { UserNotificationModel } from 'src/app/shared/models/notification.model';
import { JobActivityService } from 'src/app/job/services/job-detail/job-detail-activity.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { PropertyDashboardService } from '../../../property/services/property-dashboard.service';
import { EmailNotificationCount } from 'src/app/layout/models/email-notification-count.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService extends BaseService {
  timeLineJobReportList: string[];
  private emailCount = new Subject<number>();
  emailCount$ = this.emailCount.asObservable();
  constructor(
    private angularFireDb: AngularFireDatabase,
    private httpClient: HttpClient,
    private jobActivityService: JobActivityService,
    private oidcSecurityService: OidcSecurityService,
    private propertyActivityService: PropertyDashboardService
  ) {
    super(httpClient);
  }

  checkForNewNotifications() {
    var userId = this.oidcSecurityService.getPayloadFromIdToken(false).sub;
    return this.angularFireDb
      .list('/users/' + userId + '/notifications')
      .snapshotChanges()
      .pipe(
        map((c) => {
          return c.filter((z) => z.type === 'child_added');
        })
      )
      .subscribe((res) => {
        if (res && res.length > 0) {
          res.forEach((element) => {
            let notificationData =
              element.payload.val() as UserNotificationModel;
            this.jobActivityService.raiseEventForTimelineReportDownload(
              notificationData.notificationMessage.body,
              notificationData.dataNotification.secondaryId
            );
          });
        }
      });
  }

  getEmailNotificationCount(): any {
    var userId = this.oidcSecurityService.getPayloadFromIdToken(false).sub;
    return this.angularFireDb
      .object('/users/' + userId + '/unreadEmailNotificationCount')
      .valueChanges();
  }

  // getEmailNotificationCountById(userId : string): any {
  //   return this.angularFireDb
  //     .object('/users/' + userId + '/unreadEmailNotificationCount')
  //     .valueChanges();
  // }

  // updateEmailNotificationCount(userId: string, count: number) {
  //   const Updates = {};
  //   Updates['/users/' + userId + '/unreadEmailNotificationCount'] = count;
  //   this.angularFireDb.database.ref().update(Updates);
  // }

  checkForNewNotificationsOnPropertyTimeLine() {
    var userId = this.oidcSecurityService.getPayloadFromIdToken(false).sub;
    return this.angularFireDb
      .list('/users/' + userId + '/notifications')
      .snapshotChanges()
      .pipe(
        map((c) => {
          return c.filter((z) => z.type === 'child_added');
        })
      )
      .subscribe((res) => {
        if (res && res.length > 0) {
          res.forEach((element) => {
            let notificationData =
              element.payload.val() as UserNotificationModel;
            this.propertyActivityService.raiseEventForTimelineReportDownload(
              notificationData.notificationMessage.body,
              notificationData.dataNotification.primaryId
            );
          });
        }
      });
  }

  setEmailCount(value: number) {
    this.emailCount.next(value);
  }

}
